import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { PresentationApiService } from 'src/app/api/services/presentation-api.service';
import {
  ScrollingListFactoryService,
  ScrollingListInstance,
} from 'src/app/components/scrolling-list/services/scrolling-list-factory.service';

@Component({
  selector: 'presentation-selector',
  templateUrl: './presentation-selector-modal.component.html',
  styleUrls: ['./presentation-selector-modal.component.scss'],
  standalone: false,
})
export class PresentationSelectorModalComponent implements OnInit {
  public static PRESENTATION_SEARCH = {
    filter: '',
  };

  search: any = {
    sortBy: 'changeDate',
    reverse: true,
    name: 'Presentations',
    filter: PresentationSelectorModalComponent.PRESENTATION_SEARCH.filter,
    // Loaded in ngOnInit instead, so subclasses can scope the search in their
    // constructor before the first request goes out.
    skipFirstLoad: true,
    onListUpdate: () => {
      this.changeDetectorRef.detectChanges();
    },
  };

  presentations: ScrollingListInstance<{
    id?: string;
    name?: string;
    presentationType?: string;
    folderId?: string;
    selected?: boolean;
    revisionStatusName: string;
  }> = this.scrollingListFactory.create(
    this.presentationApiService.list.bind(this.presentationApiService),
    this.search,
  );

  filterConfig = {
    placeholder: 'Search Presentations',
    id: 'presentationSearchInput',
  };

  constructor(
    public dialogRef: MatDialogRef<PresentationSelectorModalComponent>,
    private changeDetectorRef: ChangeDetectorRef,
    private scrollingListFactory: ScrollingListFactoryService,
    private presentationApiService: PresentationApiService,
  ) {}

  ngOnInit() {
    this.presentations.load();
  }

  select(presentation) {
    this.dialogRef.close([
      presentation.id,
      presentation.name,
      presentation.presentationType,
    ]);
  }

  dismiss() {
    this.dialogRef.close(false);
  }
}
